import slugify from 'slugify';

export function upToSecondHash(str) {
  const firstHashIndex = str.indexOf('#');
  if (firstHashIndex === -1) return str; // no hash at all

  const secondHashIndex = str.indexOf('#', firstHashIndex + 1);
  if (secondHashIndex === -1) return str; // only one hash

  return str.substring(0, secondHashIndex);
}

export function scrollToProduct(slug) {
  const el = document.getElementById(slug);
  const scrollContainer = document.getElementById('app-main'); // The window is not the thing scrolling - it is the app-main element

  // Calculate the offset from the target element to take the header + product menu heights
  const header = document.getElementById('app-header');
  const offset = header.offsetHeight; // + productOptions.offsetHeight + gap;

  if (el) {
    const containerRect = scrollContainer.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();

    // compute element position relative to container content (not viewport)
    const top =
      elRect.top - containerRect.top + scrollContainer.scrollTop - offset;
    scrollContainer.scrollTo({ top, behavior: 'smooth' });
  }
}

/**
 * Canonical segment for `/product/:id-:slug` when Craft keeps the same `slug` across localized
 * entries but the title differs (GraphQL often returns one shared slug; FR URL should follow title).
 */
export function localeAwareCanonicalSlugForDetail({
  language,
  primarySiteSlug,
  entry,
}) {
  let canonical =
    (primarySiteSlug && String(primarySiteSlug).trim()) ||
    toProductSlug(entry || {});

  if (!language || language === 'en' || !entry || !entry.title) {
    return canonical;
  }

  const titleSlug = slugify(String(entry.title).trim(), {
    lower: true,
    strict: true,
    trim: true,
  });

  if (
    titleSlug &&
    canonical &&
    titleSlug.toLowerCase() !== canonical.toLowerCase()
  ) {
    return titleSlug;
  }

  return canonical;
}

export function toProductSlug(product = {}) {
  if (product.slug && String(product.slug).trim().length > 0) {
    return String(product.slug).trim();
  }
  if (product.productSlug && String(product.productSlug).trim().length > 0) {
    return String(product.productSlug).trim();
  }
  if (product.title && String(product.title).trim().length > 0) {
    return slugify(String(product.title), {
      lower: true,
      strict: true,
      trim: true,
    });
  }
  return '';
}

export function buildProductDetailRoute(product = {}) {
  const id = Number(product.id);
  const productSlug = toProductSlug(product);

  // Keep alias fallback for cases where we only know id.
  if (!productSlug) {
    return { path: `/product/${id}` };
  }

  return {
    name: 'ProductDetail',
    params: { id, productSlug },
  };
}
